export interface Dialog {
    to?: string
    type: DialogType
    params?: Array<any>
    sender: string
}

export enum DialogType {
    ROUTING = "routing", // changement de page
    REFRESH = "refresh", // refresh composant / page
    CONFIG = "config", // changement de config d'un composant
    SHOW = "show", // action contionnelle
}
